import React from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import i18n from '@i18n';
import BetbookLinkBox from '@/betbook/views/BetbookLinkBox';
import { COMMUNITY_CONDITIONS, COMMUNITY_FAQ, COMMUNITY_POSTS_AUTHOR, LOGIN } from '@/routing/routes';
import { accountUserData$, loggedIn$ } from '@/account/subs';
import NuiTitle from 'nike-ui/src/components/nui-title/NuiTitle';
import { TermsConditionsIcon } from 'nike-ui/src/icons/TermsConditionsIcon';
import { FaqIcon } from 'nike-ui/src/icons/FaqIcon';
import './MyBetbook.less';
import { POST_ANALYSIS, toBetbookAuthorPathParams } from 'nike-ui/src/components/betbook/constants';
import MyArticlesIcon from 'nike-ui/src/icons/svg/my-articles-icon-sv.svg';

function MyBetbook() {
    const { subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);
    const userData = subscribe(accountUserData$);
    const nickname = userData.nickname;

    return (
        <>
            <NuiTitle title={i18n('betbook.section.my')} center />
            <BetbookLinkBox
                title={i18n('betbook.my.posts')}
                route={loggedIn ? COMMUNITY_POSTS_AUTHOR : LOGIN}
                beforeNavigate={() => {
                    if (!loggedIn) {
                        dispatch(['login.openScreen']);
                        return false;
                    }
                    return true;
                }}
                icon={<MyArticlesIcon />}
                params={loggedIn ? toBetbookAuthorPathParams(nickname, POST_ANALYSIS) : { loginpath: 'prihlasenie' }}
                data-atid="betbook-my-posts"
            />
            <NuiTitle title={i18n('betbook.section.others')} center />
            <BetbookLinkBox
                title={i18n('betbook.conditions')}
                route={COMMUNITY_CONDITIONS}
                icon={<TermsConditionsIcon />}
            />
            <BetbookLinkBox title={i18n('betbook.faq')} route={COMMUNITY_FAQ} icon={<FaqIcon />} />
        </>
    );
}

export default MyBetbook;
